export default {"src":"/_next/static/media/bnb.d95d7f14.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};